import { render } from "./planejamento_prof.vue?vue&type=template&id=1fb962e5&scoped=true"
import script from "./planejamento_prof.vue?vue&type=script&lang=js"
export * from "./planejamento_prof.vue?vue&type=script&lang=js"

import "./planejamento_prof.vue?vue&type=style&index=0&id=1fb962e5&lang=scss&scoped=true"
import "./planejamento_prof.vue?vue&type=style&index=1&id=1fb962e5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb962e5"]])

export default __exports__